import { MissingTranslationHandler, MissingTranslationHandlerParams } from "@ngx-translate/core";

export class CustomMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams) {
    return "lt: " + params.key;

    // Save it to database or json with indicator
  }
}
